import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useCanSeeTmBackedComplianceScreen } from "./-components/is-compliance-enabled";

/** Legacy filter route — folded into Needs you (/compliance/action-required). */
export const Route = createFileRoute(
  "/(app)/_main-layout/_compliance/compliance/rejected-requirements",
)({
  component: ComplianceRejectedRequirementsRedirect,
});

function ComplianceRejectedRequirementsRedirect() {
  const tmBackedCompliance = useCanSeeTmBackedComplianceScreen();
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({
      to: tmBackedCompliance ? "/compliance/action-required" : "/compliance",
      replace: true,
    });
  }, [navigate, tmBackedCompliance]);
  return null;
}
